import { render, staticRenderFns } from "./ImportFile.vue?vue&type=template&id=8e96369a&scoped=true"
import script from "./ImportFile.vue?vue&type=script&lang=js"
export * from "./ImportFile.vue?vue&type=script&lang=js"
import style0 from "./ImportFile.vue?vue&type=style&index=0&id=8e96369a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e96369a",
  null
  
)

export default component.exports